/**
* @prop --uic-charts-gauge-chart-general-font-size: line chart base text font size
* @prop --uic-charts-gauge-chart-text-color: line chart text color (labels, tooltip etc.)
* @prop --uic-charts-gauge-chart-value-label-font-weight: value label font weight
* @prop --uic-charts-gauge-chart-value-label-font-size: value label font size
* @prop --uic-charts-gauge-chart-full-arc-stroke-color: stroke/outline color of the background full arc
* @prop --uic-charts-gauge-chart-value-arc-fill-color: fill color of the value arc
* @prop --uic-charts-gauge-chart-threshold-arc-fill-color: default fill color of the threshold arcs
* @prop --uic-charts-gauge-chart-label-gap: gap size between value and label
* @prop --uic-charts-gauge-chart-label-max-width: max width of value and label
* @prop --uic-charts-gauge-chart-loading-overlay-color: color of the loading overlay
*/

uic-gauge-chart {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
}

.uic-gauge-chart {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: var(--uic-charts-gauge-chart-general-font-size);
    color: var(--uic-charts-gauge-chart-text-color, black);
    pointer-events: none;

    &__arc--background {
        stroke: var(--uic-charts-gauge-chart-full-arc-stroke-color);
        fill: none;
    }

    &__arc--value {
        stroke: none;
        fill: var(--uic-charts-gauge-chart-value-arc-fill-color);
    }

    &__arc--threshold {
        fill: var(--uic-charts-gauge-chart-threshold-arc-fill-color);
    }

    &__label-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
    }

    &__labels {
        position: relative;
        display: flex;
        flex-direction: column;
        gap: var(--uic-charts-gauge-chart-label-gap, 3rem);
        transform: translate(0, 100%);
    }

    &__label {
        display: inline-block;
        max-width: var(--uic-charts-gauge-chart-label-max-width, 20rem);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    &__label--value {
        font-size: var(--uic-charts-gauge-chart-value-label-font-size);
        font-weight: var(--uic-charts-gauge-chart-value-label-font-weight);
    }

    &__loading_indicator {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;

        width: 100%;
        height: 100%;
        text-align: center;
        vertical-align: middle;

        background: var(--uic-charts-gauge-chart-loading-overlay-color, white);
    }

    uic-loader {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;

        width: max(188px, 25%);
        text-align: center;
        vertical-align: middle;
    }

    &__no-data-indicator {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;

        width: 100%;
        height: 100%;
    }
}
